import { Component, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { SharedState } from '@shared/state/shared/shared.state';
import { map } from 'rxjs/operators';
import { SelectOption } from '@shared/components/multi-select/models';
import { Store } from '@ngxs/store';
import { CustomIcons } from '@shared/models/custom-icons';
import { Observable } from 'rxjs';
import { AppStateService } from '../../services/app-state.service';
import { AppInfo } from '../../models/platfrom';
import { ConnectedPosition } from "@angular/cdk/overlay";

@Component({
  selector: 'app-table-filter',
  templateUrl: './table-filter.component.html',
  styleUrls: ['./table-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TableFilterComponent implements OnInit {
  private _categories: SelectOption[];
  private _platforms: SelectOption[];
  public countSelectPlatform = 0;
  public countSelectCategories = 0;
  public isActiveCategoryFilter = false;
  public allApps$: Observable<AppInfo[]>;
  public categoriesList$ = this.store.select(SharedState.getCategories).pipe(
    map(categories => {
      this._categories = categories.map(c => ({
        value: c.idOpenCategory,
        title: c?.fullName ?? '',
        isSelected: true
      }));
      this.countSelectCategories = this._categories.filter(x => x.isSelected).length;
      return this._categories;
    })
  );

  public dropDownOverlayPosition: ConnectedPosition[] = [
    {
      originX: 'center',
      originY: 'bottom',
      overlayX: 'center',
      overlayY: 'top'
    }
  ];
  public icons = CustomIcons;
  public isActivePlatformFilter = false;

  constructor(private store: Store, public appState: AppStateService) {}

  public onChooseCategories(categoryOptions: boolean[]): void {
    categoryOptions.forEach((isChosen, index) => {
      this._categories[index].isSelected = isChosen;
    });
    this.countSelectCategories = this._categories.filter(x => x.isSelected).length;
    this.appState.categories = this._categories;
    this.appState.filterPlatforms();
  }

  public onChoosePlatforms(platformOptions: boolean[]): void {
    platformOptions.forEach((isChosen, index) => {
      this._platforms[index].isSelected = isChosen;
    });
    this.countSelectPlatform = this._platforms.filter(x => x.isSelected).length;
    this.appState.platforms = this._platforms;
    this.appState.filterPlatforms();
  }

  public ngOnInit(): void {
    this._platforms = this.appState.platforms;
    this.countSelectPlatform = this._platforms.filter(x => x.isSelected).length;
    this.allApps$ = this.appState.getAllPlatforms();

    if (this.appState.categories) {
      this._categories = this.appState.categories;
      this.countSelectCategories = this._categories.filter(x => x.isSelected).length;
    }
  }
}
